import React from "react";

const features = () => {
    return (

        <section className="features section-padding">
            <div className="container">
                <div className="row">
                    <div className="col col-md-3">
                        <div className="features-title">
                            <h2>چرا ما بهترین هستیم</h2>
                            <p>در محصولات ضمن استفاده از استفاده از تکنولوژی ، نسبت به نمونه های خارجی داری قیمتی بسیار مقرون به صرفه تر هستند.</p>
                        </div>
                    </div>

                    <div className="col col-md-3 col-sm-4">
                        <div className="feature-grid">
                            <div className="icon">
                                <i className="fi flaticon-support"></i>
                            </div>
                            <div className="details">
                                <h3>پشتیبانی حرفه ای</h3>
                                <p>برای کلیه محصولات شرکت دانش بنیان آپافن ، خدمات آموزش استفاده از آنها، خدمات ‍پس از فروش و گارانتی یک ساله محصولات ارائه می گردد. </p>
                                {/* <a href="#" className="more">جزئیات <i className="fa fa-angle-left"></i></a> */}
                            </div>
                        </div>
                    </div>



                    <div className="col col-md-3 col-sm-4">
                        <div className="feature-grid">
                            <div className="icon">
                                <i className="fi flaticon-people"></i>
                            </div>
                            <div className="details">
                                <h3>مهندسان متخصص</h3>
                                <p>مهندسان شرکت دانش بنیان آپافن از برگزیدگان و مقام آوران مسابقات جهانی روبوکاپ و رباتیک کشوری هستند و بی شک در زمینه ساخت تجهیزات پیشرفته از نوابغ خطه سرزمین ما، ایران هستند. </p>
                                {/* <a href="#" className="more">جزئیات <i className="fa fa-angle-left"></i></a> */}
                            </div>
                        </div>
                    </div>

                    <div className="col col-md-3 col-sm-4">
                        <div className="feature-grid">
                            <div className="icon">
                                <i className="fi flaticon-time-passing"></i>
                            </div>
                            <div className="details">
                                <h3>تحویل به موقع</h3>
                                <p>شرکت دانش بنیان آپافن، جهت ارج نهادن به وقت شما مشتریان گرامی ، و جلب رضایت و اطمینان شما ، در اسرع وقت ممکن و در زمان مقرر کالای خریداری شده را به دست مشتری میرساند.</p>
                                {/* <a href="#" className="more">جزئیات <i className="fa fa-angle-left"></i></a> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>



    );
};

export default features; 